import {} from 'components'
import { useResponsive } from 'hooks'
import { VaultsListDesktop } from './VaultsListDesktop'
import { VaultsListMobile } from './VaultsListMobile'

export const Vault = () => {
  const { width } = useResponsive()

  return width < 800 ? <VaultsListMobile /> : <VaultsListDesktop />
}
